let apiBase = {
  queryList:'/api/activity/queryList',
  add:'/api/activity/addActivity',
  update:'/api/activity/updateActivity',
  queryDetail:'/api/activity/getInfo',
  
}
let ActivityEnrollServerObject = null
class ActivityEnrollServer{
  constructor(){}

  // 查询活动列表
  queryList(data={}){
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  add(data={}){
    return $http({
      url: apiBase.add,
      method: 'post',
      data: data,
    })
  }
  update(data={}){
    return $http({
      url: apiBase.update,
      method: 'post',
      data: data,
    })
  }
  queryDetail(data={}){
    return $http({
      url: apiBase.queryDetail,
      method: 'post',
      data: data,
    })
  }
  
}
function singleActivityEnrollServer(){
  if(ActivityEnrollServerObject === null){
    ActivityEnrollServerObject = new ActivityEnrollServer()
  }
  return ActivityEnrollServerObject
}
export default singleActivityEnrollServer()